import { ComboboxOption } from '@headlessui/react';
import type { HighlitOption } from './types';
import { Fragment } from 'react';
import { getOptionClasses } from './utils';

function HighlitLabel({ option }: { option: HighlitOption }) {
	if (option.startIndex === -1) {
		return <>{option.label}</>;
	}

	return (
		<>
			{option.label.slice(0, option.startIndex)}
			<span className="font-bold">
				{option.label.slice(option.startIndex, option.endIndex)}
			</span>
			{option.label.slice(option.endIndex)}
		</>
	);
}

export default function Option({ option }: { option: HighlitOption }) {
	return (
		<ComboboxOption as={Fragment} key={`${option.value}`} value={option}>
			{({ active }) => (
				<p className={getOptionClasses(active)}>
					<HighlitLabel option={option} />
				</p>
			)}
		</ComboboxOption>
	);
}

export function NullOption() {
	return (
		<ComboboxOption as={Fragment} value={{ label: 'Other', value: 'Other' }}>
			{({ active }) => (
				<p className={getOptionClasses(active)}>
					Can't find dealer? Click here to enter manually
				</p>
			)}
		</ComboboxOption>
	);
}
